export const environment = {
  production: true,
  apiUrl: 'https://callcenter.codebnb.me/api/',
  host: 'clearstone.codebnb.me'
};
